import type { ReactNode } from 'react';

/** Un panou cu titlu: alb, cu inel fin și umbră, ca la Stripe. */
export function Panel({
  id,
  order,
  title,
  hint,
  action,
  className,
  children,
}: {
  id?: string;
  /** locul pe ecran îngust, unde coloanele se topesc într-una */
  order?: number;
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section
      id={id}
      className={`sheet panel${className ? ` ${className}` : ''}`}
      style={order ? { order } : undefined}
    >
      <header className="panel-h">
        <h2>{title}</h2>
        {hint ? <span className="panel-hint">{hint}</span> : null}
        {action ? <span className="panel-act">{action}</span> : null}
      </header>
      {children}
    </section>
  );
}

/** Rând gol cu explicație: ce ar fi aici și de unde vine. */
export const Empty = ({ children }: { children: ReactNode }) => (
  <div className="empty dash-empty">{children}</div>
);

/** Starea, desenată (ca la Linear): cerc gol, punctat, pe jumătate, plin. */
export type StatusKind = 'new' | 'wait' | 'decide' | 'approve' | 'order' | 'late' | 'done';

export function StatusIcon({ kind }: { kind: StatusKind }) {
  const c = {
    new: '#9298A6',
    wait: '#E6782A',
    decide: '#2B3BFF',
    approve: '#070A26',
    order: '#2B3BFF',
    late: '#C2331F',
    done: '#2B3BFF',
  }[kind];
  return (
    <svg className="st-ico" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
      {kind === 'late' ? (
        <>
          <circle cx="7" cy="7" r="6.3" fill={c} />
          <path d="M7 3.8v3.6M7 9.6h.01" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
        </>
      ) : kind === 'done' ? (
        <>
          <circle cx="7" cy="7" r="6.3" fill={c} />
          <path
            d="m4.4 7.2 1.8 1.8 3.4-3.6"
            fill="none"
            stroke="#fff"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <>
          <circle
            cx="7"
            cy="7"
            r="5.6"
            fill="none"
            stroke={c}
            strokeWidth="1.4"
            strokeDasharray={kind === 'wait' ? '2.2 2' : undefined}
          />
          {kind === 'decide' ? <path d="M7 3.2a3.8 3.8 0 0 1 0 7.6z" fill={c} /> : null}
          {kind === 'approve' || kind === 'order' ? (
            <path d="M7 3.2a3.8 3.8 0 1 1-3.8 3.8H7z" fill={c} />
          ) : null}
        </>
      )}
    </svg>
  );
}
